import { inject, Injectable } from '@angular/core';
import { StateService } from '@uirouter/core';

import { UrlStateService } from './url-state.service';
import { UserAuthService } from './user-auth.service';
import { UserStateService } from './user-state.service';

@Injectable({
  providedIn: 'root',
})
export class CanAccessAppsService {
  private stateService = inject(StateService);
  private userStateService = inject(UserStateService);
  private userAuthService = inject(UserAuthService);
  private urlStateService = inject(UrlStateService);

  canAccessApps(
    signup?: boolean,
    allowReturn?: boolean,
    redirectTo?: string,
  ): Promise<void> {
    return this.userAuthService
      .authenticate(false)
      .then(() => {
        if (!this.userStateService.isRiseVisionUser()) {
          return Promise.reject();
        }
      })
      .catch(() => {
        let newState: string | undefined;

        if (!this.userStateService.isLoggedIn()) {
          if (signup) {
            newState = 'apps.auth.createaccount';
          } else {
            newState = 'apps.auth.unauthorized';
          }
        } else if (this.stateService.get('apps.auth.unregistered')) {
          newState = 'apps.auth.unregistered';
        }

        const state = redirectTo ? redirectTo : this.urlStateService.get();

        if (newState) {
          this.stateService.go(
            newState,
            {
              state,
            },
            {
              reload: true,
              location: allowReturn ? true : 'replace',
            },
          );

          return Promise.reject('unauthenticated');
        }
      });
  }
}
